import { NgModule } from '@angular/core';
import { ViewEditComponent } from './view-edit/view-edit.component';
import { ViewListComponent } from './view-list/view-list.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ViewEditComponent,
    ViewListComponent
  ],
})
export class ViewModule { }
